import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { propStr, propFunc } from '../../../../helpers/custom-prop-types';
const ConsultantSearchSliderHeader = (props) => {
    const { keyword, onChangeSearch, search, title } = props;
    return (_jsxs("div", Object.assign({ className: 'search_list_slider_header' }, { children: [_jsxs("h4", Object.assign({ className: 'search_list_slider_title' }, { children: [_jsx("span", Object.assign({ className: 'keyword' }, { children: `「${keyword}」` })), _jsx("span", { children: `の${title}検索結果` })] })), _jsx("div", Object.assign({ className: 'search_list_slider_more' }, { children: _jsx("button", Object.assign({ className: 'btn btn-tertiary small', onClick: onChangeSearch, type: 'button', value: search }, { children: "\u3059\u3079\u3066\u306E\u691C\u7D22\u7D50\u679C\u3092\u2F92\u308B" })) }))] })));
};
ConsultantSearchSliderHeader.propTypes = {
    keyword: propStr().isRequired,
    onChangeSearch: propFunc().isRequired,
    search: propStr().isRequired,
    title: propStr().isRequired,
};
export default ConsultantSearchSliderHeader;
